/**
 * serviceOrderItems — a linha de `service_order_items` num lugar só, com o
 * SNAPSHOT de custo.
 *
 * ─── POR QUE A OS ENTRA NO CMV (decisão de negócio do grupo 5) ───────────────
 *
 * `service_order_items` tinha `quantity` e `unit_price`, mas nenhuma coluna de
 * custo. Como a Ordem de Serviço é módulo GRÁTIS, pode existir SEM orçamento
 * (avulsa) e seus itens carregam `product_id`, deixá-la fora do Custo das
 * Mercadorias Vendidas subestimaria o custo e faria o lucro parecer MAIOR do que
 * é — em silêncio, que é o pior jeito de errar um número de dinheiro.
 *
 * ─── MESMO CONTRATO DE `quote_items.unit_cost` (armadilha #61) ───────────────
 *
 * - **Nullable de propósito.** Ausência de custo NUNCA é zero: zero significa
 *   "de graça" e inflaria a margem. Quem agrega conta quantos itens ficaram de
 *   fora e mostra o número (ver `src/lib/profitReport.ts`).
 * - **É SNAPSHOT, não leitura ao vivo.** O custo entra quando o item é
 *   ADICIONADO à OS (do catálogo) e nunca é relido depois. Se fosse relido no
 *   save, reeditar uma OS antiga reescreveria o custo histórico dela com o de
 *   hoje, e todo relatório de margem passado mudaria sozinho — sem erro na tela.
 *
 * Não há builder único no orçamento por acaso: os payloads de
 * `service_order_items` também são montados por LISTA EXPLÍCITA de colunas em
 * mais de um lugar (formulário online e executor da fila offline), que é
 * exatamente a armadilha #33/#62. O guard de varredura cobra a coluna nos dois.
 */
import { productUnitCost } from '@/lib/cost';

/** O mínimo que estas funções precisam de um item de OS. */
export interface ServiceOrderItemLike {
  unit_cost?: number | string | null;
}

/**
 * Custo unitário que a linha da OS grava — o snapshot que o item já carrega,
 * nunca uma leitura nova de `products.cost`.
 *
 * Reaproveita a normalização de custo do catálogo: `''`/`null`/negativo → null,
 * e o **zero é preservado** (item de brinde tem custo zero de verdade).
 */
export function serviceOrderItemUnitCost(
  item: ServiceOrderItemLike | null | undefined,
): number | null {
  return productUnitCost({ cost: item?.unit_cost ?? null });
}
